module.exports = __webpack_public_path__ + "static/media/404-luftfahrt.b85a58f7.png";